import { apiClient } from "shared/utils";
import { ActivationPopupsExperimentalTemplatesConfiguration } from "api/models";

export const putActivationPopupsExperimentalTemplatesConfiguration = async ({
  shopId,
  experimentalTemplatesEnabled
}: ActivationPopupsExperimentalTemplatesConfiguration & { shopId: number }) => {
  const { data } = await apiClient.put<void>(
    `/${shopId}/activation-popups/experimental-templates`,
    {
      experimentalTemplatesEnabled
    }
  );

  return data;
};
